



import { getDataTableCellRawValue } from './factories/dataTableCellValueFactory';
import { SORT_DIRECTION } from '../../../../common/constants/sortDirection';
import { getDataTableColumnByField } from './factories/dataTableColumnFactory';


export const getDataTableColumnSortValue = (
field,
currentSort) =>

currentSort && currentSort.field === field ? currentSort.direction : null;


export const getDataTableNewSort = (
field,
newSort) =>
newSort ? {
  field,
  direction: newSort
} : null;


export const isDataTableColumnSortAvailable = (
isSortable,
hasTableData) =>
isSortable && hasTableData;

export const sortDataTableFlatRowsNodes = (
flatRowsNodes,
columns,
sort) =>
{
  if (!sort) {
    return flatRowsNodes;
  }

  const sortColumn = getDataTableColumnByField(sort.field, columns);
  if (!sortColumn) {
    return flatRowsNodes;
  }

  const { getValueComparator } = sortColumn;
  if (!getValueComparator) {
    return flatRowsNodes;
  }

  const sorted = [...flatRowsNodes].sort((rowA, rowB) => {
    const valueA = getDataTableCellRawValue(rowA.data, sortColumn.field);
    const valueB = getDataTableCellRawValue(rowB.data, sortColumn.field);

    return getValueComparator(valueA, valueB, rowA.data, rowB.data);
  });

  if (sort.direction === SORT_DIRECTION.DESC) {
    sorted.reverse();
  }

  return sorted;
};